/**
 * The one place that reads which axes a card can move along. A server that predates the
 * per-axis flags sends only `canMove` and `viewerCanMoveItems`, which cover both axes, so
 * each per-axis flag falls back to them. Either repository can deploy first.
 *
 * Absent reads as `false` on both, and a board with no row field has no row to move to.
 */

import type {SavedViewsBoardData, SavedViewsBoardItem} from './types'

export function normalizeItemMoves<TItem extends SavedViewsBoardItem>(item: TItem, hasRows: boolean): TItem {
  return {
    ...item,
    canMoveBetweenColumns: item.canMoveBetweenColumns ?? item.canMove ?? false,
    canMoveBetweenRows: hasRows && (item.canMoveBetweenRows ?? item.canMove ?? false),
  }
}

export function normalizeBoardMoves<TItem extends SavedViewsBoardItem>(
  boardData: SavedViewsBoardData<TItem>,
): SavedViewsBoardData<TItem> {
  const {data, rowField, viewerCanMoveItems} = boardData
  const hasRows = rowField != null

  return {
    ...boardData,
    data: {
      ...data,
      cells: data.cells.map(cell => ({...cell, items: cell.items.map(item => normalizeItemMoves(item, hasRows))})),
    },
    viewerCanMoveBetweenColumns: boardData.viewerCanMoveBetweenColumns ?? viewerCanMoveItems ?? false,
    viewerCanMoveBetweenRows: hasRows && (boardData.viewerCanMoveBetweenRows ?? viewerCanMoveItems ?? false),
  }
}
